import { FC, useMemo } from 'react'
import {
  getTariffPriceWithDiscount,
  getTariffOldPrice,
  getTariffPrice,
  getPromoCodeDiscountString,
} from '../../utils/tariff'
import cn from './index.module.css'
import { useGetSettings } from '@pages/CoursesCatalog/tabs/CatalogCoursesTab/hooks/getPlatformSettings'

interface ICoursePriceView {
  tariff?: ICourseTariff
  value?: number
  promoCode?: IPromoCodeDiscount
  withDemo: boolean
}

const CoursePriceView: FC<ICoursePriceView> = ({
  tariff,
  value,
  promoCode,
  withDemo,
}) => {
  const { checkSettings } = useGetSettings()
  const showOldPriceSettings = checkSettings('catalog_showOldPrice')

  const price = useMemo(() => {
    return getTariffPriceWithDiscount(tariff, value, promoCode)
  }, [tariff?.first_price, promoCode, value])

  const oldPrice = useMemo(() => {
    if (promoCode) {
      return getTariffPrice(tariff, value)
    }
    return getTariffOldPrice(tariff, value)
  }, [tariff?.old_price, value])

  if (!tariff || !value) return <></>

  const showOldPrice = (showOldPriceSettings && oldPrice) || promoCode

  return (
    <div className={cn.priceContainer}>
      {tariff?.type === 'free' || withDemo ? (
        <div className={cn.currentPrice}>{withDemo ? 'Демо' : 'Бесплатно'}</div>
      ) : (
        <>
          <div className={cn.promoContainer}>
            <div className={cn.currentPrice}>{price}р</div>
            {promoCode && (
              <div className={cn.promoTitle}>
                {getPromoCodeDiscountString(promoCode)}
              </div>
            )}
          </div>
          {showOldPrice && <div className={cn.oldPrice}>{oldPrice}р</div>}
        </>
      )}
    </div>
  )
}

export default CoursePriceView
